import { getArgumentValue } from '../getArgumentValue.js';

const hasBlockReference = (arg) => {
  if (arg?.type !== 'lexical' || !arg?.value?.root?.children) {
    return false;
  }
  const checkChildren = (children) => {
    return children.some((child) => {
      if (child.type === 'block') {
        return true;
      }
      if (child.children) {
        return checkChildren(child.children);
      }
      return false;
    });
  };
  return checkChildren(arg.value.root.children);
};

export const validateHttpRequest = async ({ step, status }) => {
  const args = step?.arguments;
  const urlValue = await getArgumentValue({ arg: args?.url, opts: { format: 'human' } });

  if (!urlValue) {
    return { status, message: 'Set URL' };
  }

  // Only validate URL format if it's a literal URL (not a variable reference)
  if (urlValue && !hasBlockReference(args?.url)) {
    try {
      new URL(urlValue); // eslint-disable-line no-new
    } catch (error) {
      console.log(error);
      return { status: 'invalid', message: 'Invalid URL' };
    }
  }

  return { status: 'valid' };
};
